import React, { useState, useEffect } from 'react';
import './App.css';
import { useAuth0 } from "@auth0/auth0-react";
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from "react-router-dom";
import FAQ from './faq';
import Blogs from './Blogs';
import Settings from './Settings';
import MyProfile from './MyProfile';
import NotifyList from './notifylist';
import Home from './Home';
import { HomeProvider } from './HomeContext';
import ProductDetails from './ProductDetails';
import Compare from './Compare';
import InstallPWA from './components/InstallPWA';


function App() {
  const { loginWithRedirect, isAuthenticated, user, getAccessTokenSilently, logout } = useAuth0();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth >= 768) {
        setMenuOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      const menu = document.getElementById('mobile-menu');
      const hamburger = document.getElementById('hamburger-button');
      
      if (menuOpen && menu && hamburger && !menu.contains(target) && !hamburger.contains(target)) {
        setMenuOpen(false);
      }
    };

    if (menuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuOpen]);

  return (
    <HomeProvider>
      <Router>
        <div className="App" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
          {/* Header with menu */}
          <header style={{
            background: '#222',
            color: '#fff',
            padding: '0 0 0 0',
            marginBottom: 32,
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
          }}>
            <div style={{
              maxWidth: 1200,
              margin: '0 auto',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '0 12px',
              height: 64
            }}>
              <div style={{ 
                fontWeight: 700, 
                fontSize: isMobile ? 18 : 24, 
                letterSpacing: 1,
                whiteSpace: 'nowrap' 
              }}>Price Tracker</div>
              
              {/* Mobile Hamburger Menu */}
              {isMobile ? (
                <>
                  <button
                    id="hamburger-button"
                    onClick={() => setMenuOpen(!menuOpen)}
                    style={{
                      background: 'transparent',
                      border: 'none',
                      color: '#fff',
                      fontSize: 28,
                      cursor: 'pointer',
                      padding: 8
                    }}
                  >
                    ☰
                  </button>
                  
                  {/* Mobile Menu Dropdown */}
                  {menuOpen && (
                    <div 
                      id="mobile-menu"
                      style={{
                      position: 'absolute',
                      top: 64,
                      left: 0,
                      background: '#222',
                      width: '100%',
                      boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                      zIndex: 1000,
                      padding: '12px 0'
                    }}>
                      <Link to="/" onClick={() => setMenuOpen(false)} style={{ display: 'block', color: '#fff', textDecoration: 'none', padding: '12px 24px', fontSize: 16, textAlign: 'left' }}>Home</Link>
                      <Link to="/notifylist" onClick={() => setMenuOpen(false)} style={{ display: 'block', color: '#fff', textDecoration: 'none', padding: '12px 24px', fontSize: 16, textAlign: 'left' }}>NotifyList</Link>
                      <Link to="/blogs" onClick={() => setMenuOpen(false)} style={{ display: 'block', color: '#fff', textDecoration: 'none', padding: '12px 24px', fontSize: 16, textAlign: 'left' }}>Blogs</Link>
                      <Link to="/faq" onClick={() => setMenuOpen(false)} style={{ display: 'block', color: '#fff', textDecoration: 'none', padding: '12px 24px', fontSize: 16, textAlign: 'left' }}>FAQ</Link>
                      
                      {isAuthenticated && (
                        <>
                          <Link to="/profile" onClick={() => setMenuOpen(false)} style={{ display: 'block', color: '#fff', textDecoration: 'none', padding: '12px 24px', fontSize: 16, textAlign: 'left' }}>My Profile</Link>
                          <Link to="/settings" onClick={() => setMenuOpen(false)} style={{ display: 'block', color: '#fff', textDecoration: 'none', padding: '12px 24px', fontSize: 16, textAlign: 'left' }}>Settings</Link>
                          <div style={{ padding: '12px 24px' }}>
                            <button
                              onClick={() => {
                                setMenuOpen(false);
                                logout({ logoutParams: { returnTo: window.location.origin } });
                              }}
                              style={{
                                background: '#ef4444',
                                color: '#fff',
                                border: 'none',
                                borderRadius: 4,
                                padding: '8px 16px',
                                cursor: 'pointer',
                                fontSize: 14,
                                fontWeight: 600,
                                width: '100%',
                                textAlign: 'left'
                              }}
                            >
                              Logout
                            </button>
                          </div>
                        </>
                      )}
                      
                      {!isAuthenticated && (
                        <div style={{ padding: '12px 24px' }}>
                          <button
                            onClick={() => {
                              setMenuOpen(false);
                              loginWithRedirect();
                            }}
                            style={{
                              background: '#2563eb',
                              color: '#fff',
                              border: 'none',
                              borderRadius: 4,
                              padding: '8px 16px',
                              cursor: 'pointer',
                              fontSize: 14,
                              fontWeight: 600,
                              width: '100%',
                              textAlign: 'left'
                            }}
                          >
                            Login
                          </button>
                        </div>
                      )}
                    </div>
                  )}
                </>
              ) : (
                /* Desktop Navigation */
                <nav style={{ display: 'flex', alignItems: 'center' }}>
                  <Link to="/" style={{ color: '#fff', textDecoration: 'none', marginRight: 24, fontSize: 16 }}>Home</Link>
                  <Link to="/notifylist" style={{ color: '#fff', textDecoration: 'none', marginRight: 24, fontSize: 16 }}>NotifyList</Link>
                  <Link to="/blogs" style={{ color: '#fff', textDecoration: 'none', marginRight: 24, fontSize: 16 }}>Blogs</Link>
                  <Link to="/faq" style={{ color: '#fff', textDecoration: 'none', marginRight: 24, fontSize: 16 }}>FAQ</Link>
                  
                  {/* Authenticated user links */}
                  {isAuthenticated && (
                    <>
                      <Link to="/profile" style={{ color: '#fff', textDecoration: 'none', marginRight: 24, fontSize: 16 }}>My Profile</Link>
                      <Link to="/settings" style={{ color: '#fff', textDecoration: 'none', marginRight: 24, fontSize: 16 }}>Settings</Link>
                    </>
                  )}

                  {isAuthenticated && (
                    <button
                      onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
                      style={{
                        background: '#ef4444',
                        color: '#fff',
                        border: 'none',
                        borderRadius: 4,
                        padding: '6px 16px',
                        cursor: 'pointer',
                        fontSize: 14,
                        fontWeight: 600
                      }}
                    >
                      Logout
                    </button>
                  )}
                  
                  {!isAuthenticated && (
                    <button
                      onClick={() => loginWithRedirect()}
                      style={{
                        background: '#2563eb',
                        color: '#fff',
                        border: 'none',
                        borderRadius: 4,
                        padding: '8px 20px',
                        cursor: 'pointer',
                        fontWeight: 600,
                        fontSize: 14
                      }}
                    >
                      Login
                    </button>
                  )}
                </nav>
              )}
            </div>
          </header>

          {/* Main content with routes */}
          <main style={{ flex: 1 }}>
            <Routes>
              <Route path="/" element={
                <Home
                  user={user}
                  loginWithRedirect={loginWithRedirect}
                  getAccessTokenSilently={getAccessTokenSilently}
                />
              } />
            
              <Route path="/notifylist" element={<NotifyList />} />
                <Route path="/faq" element={<FAQ />} />
              <Route path="/blogs" element={<Blogs />} />
              <Route path="/product/:id" element={<ProductDetails />} />
              <Route path="/compare" element={<Compare />} />
              <Route path="/profile" element={<MyProfile />} />
              <Route path="/settings" element={<Settings />} />
              
              {/* Catch-all route - redirect any unmatched routes to home */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>

          {/* Footer */}
          <footer style={{
            background: '#222',
            color: '#fff',
            textAlign: 'center',
            padding: '18px 0',
            marginTop: 32
          }}>
            &copy; {new Date().getFullYear()} ShoeHub &mdash; All rights reserved.
          </footer>
          
          {/* Install PWA Banner */}
          <InstallPWA />
        </div>
      </Router>
    </HomeProvider>
  );
}

export default App;